import React from "react";
import classnames from "classnames";
import filesize from "filesize";
import * as qs from "qs";

import { HStack } from "@formant/ui/component/common/HStack";

import { track } from "../../../analytics";
import { webvizEndpoint } from "../../../config";
import { formatTime } from "../../../utils/formatTime";
import { DeviceName } from "../../common/DeviceName";
import { IconButton } from "../../common/IconButton";
import { Tags } from "../../common/Tags";
import { TextButton } from "../../common/TextButton";
import { DeepPureComponent } from "../../DeepPureComponent";
import { AssetImage } from "../AssetImage";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import * as styles from "./FileModuleListItem.scss";

export interface IFileModuleListItemProps {
    point: IMetadataDataPoint<"file">;
    old: boolean;
    live?: boolean;
    hideDevice?: boolean;
    utc: boolean;
    onClick?: (time: Date) => void;
}

export class FileModuleListItem extends DeepPureComponent<IFileModuleListItemProps> {
    public render() {
        const { point, old, live, hideDevice } = this.props;
        const { deviceId, tags, time, value } = point;
        const { url, filename, size, previewUrl } = value;
        const isBag = filename.endsWith(".bag");

        return (
            <div
                className={classnames(
                    styles["file-module-list-item"],
                    !old && styles.current,
                    !old && live && styles.live,
                )}
                onClick={this.onClick}
            >
                <HStack hAlign="space-between">
                    {!hideDevice && (
                        <div className={styles.device}>
                            <DeviceName id={deviceId} size="18" />
                        </div>
                    )}
                    <div className={styles.time}>
                        {formatTime(time, { milliseconds: false })}
                    </div>
                </HStack>

                <HStack
                    hAlign="stretch"
                    className={styles.file}
                    vAlign="center"
                >
                    {!isBag && previewUrl && (
                        <AssetImage
                            src={previewUrl}
                            className={styles.preview}
                        />
                    )}
                    {isBag && webvizEndpoint && (
                        <IconButton
                            icon="play"
                            to={`${webvizEndpoint}?${qs.stringify({
                                "remote-bag-url": url,
                            })}`}
                            target="_blank"
                            onClick={this.onClickBagPlay}
                            className={styles.play}
                        />
                    )}
                    <TextButton
                        to={url}
                        data-tooltip={filename}
                        target="_blank"
                        onClick={this.onDownload}
                        className={styles.download}
                    >
                        {filename}
                    </TextButton>
                    <div className={styles.size}>{filesize(size || 0)}</div>
                </HStack>
                {!hideDevice && <Tags tags={tags} className={styles.tags} />}
            </div>
        );
    }

    private onClick = () => {
        const { point, onClick } = this.props;
        if (onClick) {
            onClick(point.time);
        }
    };

    private onDownload = () => {
        const { point } = this.props;
        const { value } = point;
        const { filename } = value;
        const isBag = filename.endsWith(".bag");

        track("Download File");

        if (isBag) {
            track("Download Rosbag");
        }
    };

    private onClickBagPlay = () => {
        track("Play Rosbag");
    };
}
